export const WAITLIST_POOL_ID = 'WAITLIST_POOL_ID';
export const WAITLIST_DRIVER_ID = 'WAITLIST_DRIVER_ID';
